import { ensureBookingIframe } from './booking.js'
import {
  disableLenis,
  enableLenis,
  pauseLenis,
  resumeLenis
} from './lenisScroll.js'

/**
 * Pause page smooth-scroll. Booking destroys Lenis entirely so the iframe
 * modal can use native overflow without wheel fights.
 * @param {string} modalName
 */
function pausePageScroll (modalName) {
  if (modalName === 'booking') {
    disableLenis()
    return
  }

  pauseLenis()
}

/**
 * @param {string} modalName
 */
function resumePageScroll (modalName) {
  if (modalName === 'booking') {
    enableLenis()
    return
  }

  resumeLenis()
}

function modal () {
  const html = document.querySelector('html')
  const modaLinks = document.querySelectorAll('.open-modal')
  const btnClose = document.querySelectorAll('.modal .close')
  const allModals = document.querySelectorAll('.modal')

  function closeModal (modalEl) {
    if (!modalEl) return

    const modalName = modalEl.dataset.modal || ''

    modalEl.dataset.show = 'off'
    html.dataset.modal = 'off'
    resumePageScroll(modalName)
  }

  function handleClickOutside (modalEl, modalContent, modalType, event) {
    if (!modalContent.contains(event.target)) {
      if (modalType === 'gallery') {
        setTimeout(() => window.gallerySwiper?.destroy(), 1000)
      }

      closeModal(modalEl)
    }
  }

  modaLinks.forEach((btnModal) => {
    btnModal.onclick = (e) => {
      e.preventDefault()
      e.stopPropagation()

      const modaLink = btnModal.dataset.modal
      const modalEl = document.querySelector(
        `.modal[data-modal="${modaLink}"]`
      )

      if (!modalEl) return

      const modalType = modalEl.dataset.type
      html.dataset.modal = 'on'
      modalEl.dataset.show = 'on'
      pausePageScroll(modaLink)

      if (modaLink === 'booking') {
        ensureBookingIframe()
      } else {
        const lazyIframe = modalEl.querySelector('iframe[data-src]')

        if (lazyIframe && !lazyIframe.getAttribute('src')) {
          const iframeSrc = lazyIframe.getAttribute('data-src')

          if (iframeSrc) lazyIframe.setAttribute('src', iframeSrc)
        }
      }

      if (modalType === 'video') {
        const modalVideo = modalEl.querySelector('video')

        if (modalVideo) modalVideo.play()
      }
    }
  })

  allModals.forEach((modalEl) => {
    modalEl.addEventListener('click', (event) => {
      const modalContent = modalEl.querySelector('.modal-box')
      const modalType = modalEl.dataset.type

      if (!modalContent) return

      handleClickOutside(modalEl, modalContent, modalType, event)
    })
  })

  if (btnClose) {
    btnClose.forEach((close) => {
      close.addEventListener('click', (e) => {
        e.preventDefault()

        const thisModal = close.closest('.modal')

        if (!thisModal) return

        const modalName = thisModal.dataset.modal || ''

        thisModal.dataset.show = 'off'
        resumePageScroll(modalName)

        setTimeout(() => {
          html.dataset.modal = 'off'
        }, 300)
      })
    })
  }
}

export default modal
